import * as React from 'react';

export const PrivacyPolicy = () => (
  <>
    <br />
    Trac Technologies, Inc. (“Trac”) respects your privacy and is committed to
    protecting it through compliance with this policy. This policy describes the
    types of information Trac may collect from you or that you may provide when
    you visit the website{' '}
    <a
      className="link-line"
      href="http://trac.co"
      target="_blank"
      rel="noopener noreferrer"
    >
      http://trac.co
    </a>{' '}
    (the “Website”), including through use of the services offered through the
    Website (the “Services”), and the purchase of products or services from the
    Website, and Trac’s practices for collecting, using, maintaining,
    protecting, and disclosing that information.
    <br />
    <br />
    Please read this policy carefully to understand Trac’s policies and
    practices regarding your information and how Trac will treat it. If you do
    not agree with Trac’s policies and practices, your choice is not to use the
    Website. By accessing or using the Website, you agree to this privacy
    policy. This policy may change from time to time with or without notice to
    you. Your continued use of this Website after Trac makes changes is deemed
    to be acceptance of those changes, so please check the policy periodically
    for updates.
    <br />
    <br />
    This policy is independent of other privacy policy published by third party
    operating a site or an application or service to which the Website or
    Services refers to or redirects to. Some features, such as data sharing,
    offer you the possibility of granting third parties access to your
    information. Please be aware that how these third parties handle your
    information is under the privacy policies of those third parties.
    <br />
    <br />
    <br />
    <br />
    <b>1. Information Trac Collects</b>
    <br />
    <br />
    Depending on your level of interaction with the Website and the Services,
    Trac collects several types of information from and about users of the
    Website, including:
    <br />
    <br />
    &#8226; Name, professional name, biographical information
    <br />
    &#8226; Address, telephone number, email address
    <br />
    &#8226; Banking, credit card, and other financial information
    <br />
    &#8226; Driver’s license or other government ID number
    <br />
    &#8226; Federal tax identification number
    <br />
    &#8226; Songs, recordings, images, designs, videos, and other works (“User
    Contributions”)
    <br />
    &#8226; Metadata concerning User Contributions
    <br />
    &#8226; IP addresses and information regarding your type of device, screen
    resolution, version of operating system, type and version of the Internet
    browser
    <br />
    &#8226; Log files and other information collected through cookies and other
    customary tracking technologies
    <br />
    &#8226; Demographic data on users
    <br />
    &#8226; Data regarding user behavior on the Website and using the Services
    <br />
    &#8226; Technical information, such as cookies
    <br />
    &#8226; Geolocation data
    <br />
    &#8226; Information concerning your collaborators and other individuals
    associated with User Contributions
    <br />
    &#8226; Other information you voluntarily provide during your use of the
    Website or the Services
    <br />
    &#8226; Other information you voluntarily provide during your use of the
    Website or the Services
    <br />
    <br />
    Trac collects this information:
    <br />
    <br />
    &#8226; Directly from you when you provide it to Trac when creating an
    account, purchasing product, subscribing to a service, managing payments,
    making claims, uploading User Contributions.
    <br />
    &#8226; Automatically as you navigate through the Website.
    <br />
    &#8226; From third-party Services partners and public databases.
    <br />
    &#8226; Browsers, devices, and widgets, server log files, and cookies
    <br />
    <br />
    <br />
    <br />
    <b>2. Use of Your Information</b>
    <br />
    <br />
    Trac uses information collected about you or that you provide:
    <br />
    <br />
    &#8226; To present the Website and its contents to you.
    <br />
    &#8226; To provide you with information, products, or services that you
    request from Trac.
    <br />
    &#8226; To fulfill any other purpose for which you provide it.
    <br />
    &#8226; To provide you with notices about your account/subscription,
    including expiration and renewal notices.
    <br />
    &#8226; To carry out Trac’s obligations and enforce its rights arising from
    any contracts entered into between you and Trac, including for billing and
    collection.
    <br />
    &#8226; To notify you about changes to the Website or any products or
    services offered or provided though it.
    <br />
    &#8226; To allow you to participate in interactive features on the Website.
    <br />
    &#8226; To maintain and improve the content and functionality of the
    Services.
    <br />
    &#8226; To develop business and inform Trac’s marketing strategy.
    <br />
    &#8226; In any other way Trac may describe when you provide the information.
    <br />
    &#8226; For any other purpose with your consent.
    <br />
    <br />
    <br />
    <br />
    <b>3. Disclosure of Your Information</b>
    <br />
    <br />
    Trac may disclose aggregated information about its users, and information
    that does not identify any individual, without restriction.
    <br />
    <br />
    Trac may disclose personal information it collects, or which is otherwise
    provided by you:
    <br />
    <br />
    &#8226; To its subsidiaries and affiliates.
    <br />
    &#8226; To contractors, service providers, and other third parties it uses
    to support the Website and the Services.
    <br />
    &#8226; To fulfill the purpose for which you provide it.
    <br />
    &#8226; For any other purpose disclosed to you when you provide the
    information.
    <br />
    &#8226; To comply with any court order, law, or legal process, including to
    respond to any government or regulatory request.
    <br />
    &#8226; To enforce or apply the Terms of Use and other agreements between
    you and Trac, including for billing and collection purposes.
    <br />
    &#8226; To protect the rights, property, or safety of Trac, its customers,
    or others.
    <br />
    &#8226; Trac does not sell your personal information to third parties for
    money. However, Trac may share personal information with other companies and
    service providers in compliance with the law in order to deliver more
    meaningful ads and other communications to consumers, and for other similar
    reasons provided in this policy.
    <br />
    <br />
    <br />
    <br />
    <b>4. Choices About Use and Disclosure of Your Information</b>
    <br />
    <br />
    &#8226; You can review and change your personal information by logging into
    the Website and visiting your account profile page.
    <br />
    &#8226; You may also send Trac an email at{' '}
    <a
      className="link-line"
      target="_blank"
      rel="noopener noreferrer"
      href="mailto:support@trac.co"
    >
      support@trac.co
    </a>{' '}
    to request access to, correct or delete any personal information that you
    have provided to Trac. Trac may not accommodate a request to change
    information if it believes the change would violate any law or legal
    requirement or cause the information to be incorrect.
    <br />
    &#8226; If you delete your User Contributions from the Website, copies of
    your User Contributions may remain viewable in cached and archived pages, or
    might have been copied or stored by other Website users.
    <br />
    &#8226; You can set your browser to refuse all or some browser cookies, or
    to alert you when cookies are being sent. If you disable or refuse cookies,
    please note that some parts of the Website may then be inaccessible or not
    function properly.
    <br />
    &#8226; California residents may have additional personal information rights
    and choices. Subject to certain exceptions, California residents can (i)
    request access to specific pieces of personal information that Trac
    collects, uses, discloses, or sells and information about Trac’s data
    practices; (ii) request deletion of your personal information; and (iii) opt
    out of sharing with third parties for certain commercial purposes. If you
    wish to exercise this right, please email{' '}
    <a
      className="link-line"
      target="_blank"
      rel="noopener noreferrer"
      href="mailto:support@trac.co"
    >
      support@trac.co
    </a>
    . Additionally, California Civil Code Section 1798.83 provides you the right
    to receive information identifying any third party(ies) to whom Trac may
    have disclosed your personal information for that third party’s direct
    marketing purposes, and a description of the categories of personal
    information disclosed. If you wish to request this information, please email{' '}
    <a
      className="link-line"
      target="_blank"
      rel="noopener noreferrer"
      href="mailto:support@trac.co"
    >
      support@trac.co
    </a>
    .
    <br />
    &#8226; Under the GDPR, you may have additional rights under certain
    conditions, including: (i) the right to withdraw consent to processing where
    processing requires consent; (ii) the right to access your personal
    pnformation and certain other supplementary information; (iii) the right to
    refuse unlawful data processing; (iv) the right to remove personal
    information about you; (v) the right to demand that Trac limit the
    processing of your personal information; (vi) the right to move, copy, or
    transfer of your personal information that you provided Trac; (vii) the
    right to refuse automated procedures that may have legal effects for you;
    (viii) the right to send a complaint to data protection authorities. If you
    want to learn more about your rights under the GDPR, you can visit the
    European Commission’s page on Data Protection at:{' '}
    <a
      className="link-line"
      href="https://ec.europa.eu/info/law/law-topic/data-protection_en"
      target="_blank"
      rel="noopener noreferrer"
    >
      https://ec.europa.eu/info/law/law-topic/data-protection_en
    </a>
    .
    <br />
    <br />
    <br />
    <br />
    <b>5. Data Security</b>
    <br />
    <br />
    Trac has implemented measures designed to secure your personal information
    from accidental loss and from unauthorized access, use, alteration, and
    disclosure. However, much of the safety and security of your information
    also depends on you. Where Trac has given you (or where you have chosen) a
    password for access to certain parts of the Website or the Services, you are
    responsible for keeping this password confidential. Unfortunately, the
    transmission of information via the internet is not completely secure.
    Although Trac does its best to protect your personal information, Trac
    cannot guarantee the security of your personal information transmitted to
    the Website. Any transmission of personal information is at your own risk.
    <br />
    <br />
    <br />
    <br />
    <b>6. Children Under the Age of 16</b>
    <br />
    <br />
    The Website is not intended for children under 16 years of age. No one under
    age 16 may provide any personal information to or on the Website. Trac does
    not knowingly collect personal information from children under 16. If you
    are under 16, do not use or provide any information on this Website or
    through any of its features, register on the Website, make any purchases
    through the Website, use any of the interactive or public comment features
    of this Website, or provide any information about yourself to Trac,
    including your name, address, telephone number, email address, or any screen
    name or user name you may use. If you believe Trac might have any
    information from or about a child under 16, please contact{' '}
    <a
      className="link-line"
      target="_blank"
      rel="noopener noreferrer"
      href="mailto:support@trac.co"
    >
      support@trac.co
    </a>
    .
    <br />
    <br />
    <br />
    <br />
    <b>7. Contact Information</b>
    <br />
    <br />
    To ask questions or comment about this privacy policy and Trac’s privacy
    practices, contact Trac at:{' '}
    <a
      className="link-line"
      target="_blank"
      rel="noopener noreferrer"
      href="mailto:support@trac.co"
    >
      support@trac.co
    </a>
    .
  </>
);

export default PrivacyPolicy;
